/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { action } from 'typesafe-actions';
import { FiltersActionTypes } from './types';

export const saveFilter = (key: string, values: string[]) => action(FiltersActionTypes.SAVE_FILTER, { key, values });
export const removeFilter = (key: string) => action(FiltersActionTypes.REMOVE_FILTER, key);
export const clearAllFilters = () => action(FiltersActionTypes.CLEAR_ALL_FILTERS);

export const addExpanded = (key: string) => action(FiltersActionTypes.ADD_EXPANDED, key);
export const removeExpanded = (key: string) => action(FiltersActionTypes.REMOVE_EXPANDED, key);
export const saveSearchValue = (searchValue: string) => action(FiltersActionTypes.SAVE_SEARCH_VALUE, searchValue);
